import { observable, action } from 'mobx';
import { SHOP_LOCALE } from './constants';

const DEFAULT_LANGUAGE_CODE = 'en';

export const LanguageState = observable({
  languageCode: SHOP_LOCALE || DEFAULT_LANGUAGE_CODE,
});

export const updateLanguageCode = action(
  (languageCode: string | undefined | null, { updateUserPreference = false } = {}) => {
    if (!languageCode) return false;
    LanguageState.languageCode = languageCode;
    return !!languageCode;
  }
);
